import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PreviewCardPage = () => {
  return (
    <>
      <Helmet>
        <title>VoiceInk Preview Card</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="max-w-[1200px] h-[630px] bg-gradient-to-br from-[var(--vi-bg-preview-start)] to-[var(--vi-bg-preview-end)] flex items-center justify-center p-16">
        <div className="flex items-center gap-12">
          <img
            src="/favicon.png"
            alt="VoiceInk Logo"
            className="w-48 h-48 rounded-3xl shadow-2xl"
          />
          <div className="space-y-6">
            <h1 className="text-7xl font-bold text-[var(--vi-text-inverse)]">
              Voice<span className="bg-gradient-to-r from-[var(--vi-accent-support)] to-[var(--vi-accent-primary)] bg-clip-text text-transparent">Ink</span>
            </h1>
            <p className="text-3xl text-[var(--vi-text-subtle)]">
              Transform Speech to Text Instantly on Mac
            </p>
            <div className="flex items-center gap-4">
              <div className="px-4 py-2 bg-[var(--vi-fill-support-20)] rounded-full border border-[var(--vi-fill-support-18)]">
                <span className="text-xl text-[var(--vi-accent-support)]">Offline AI</span>
              </div>
              <div className="px-4 py-2 bg-[var(--vi-fill-accent-20)] rounded-full border border-[var(--vi-fill-accent-18)]">
                <span className="text-xl text-[var(--vi-accent-primary)]">100+ Languages</span>
              </div>
              <div className="px-4 py-2 bg-[var(--vi-fill-support-20)] rounded-full border border-[var(--vi-fill-support-18)]">
                <span className="text-xl text-[var(--vi-accent-support)]">Privacy Focused</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewCardPage; 
